import { AvvirEvent } from "type_aliases";

export type FileUploadStartedEvent = AvvirEvent<typeof FILE_UPLOAD_STARTED, { fileTitle: string }>

const fileUploadStarted = (fileTitle: string): FileUploadStartedEvent => ({
  type: FILE_UPLOAD_STARTED,
  payload: {
    fileTitle
  }
});

export const FILE_UPLOAD_STARTED = "file_upload_started";

export default fileUploadStarted;
